import { Footer, Header, SEO } from "@/components";
import SEOConfig from "@/common/seo.config";
import { fetchBlogList } from "@/lib/blogs";
import { HOME_BLOG_LIMIT } from "@/components/main/aiBlog";
import { fetchServiceSolutions } from "@/lib/service-solutions";
import RelatedSolutionsComponent from "@/common/related-solutions";
import AiIntegrationsComponent, {
  FAQS,
} from "@/components/services/ai-integrations";
import React from "react";
import { buildServicePageSchema } from "@/lib/service-page-schema";

const PATH = "/ai-integrations";

function AiIntegrations({ posts = [], relatedSolutions = [] }) {
  return (
    <>
      <SEO
        {...SEOConfig.aiIntegrations}
        structuredData={buildServicePageSchema({
          config: SEOConfig.aiIntegrations,
          path: PATH,
          faqs: FAQS,
          serviceType: "AI Integrations",
        })}
      />
      <Header />
      <main>
        <AiIntegrationsComponent posts={posts} />
        <RelatedSolutionsComponent
          data={relatedSolutions}
          title="Solutions built on this capability"
          subtitle="Where we apply this work for specific teams and industries."
        />
      </main>
      <Footer />
    </>
  );
}

export async function getStaticProps() {
  const [posts, relatedSolutions] = await Promise.all([
    fetchBlogList({ limit: HOME_BLOG_LIMIT }),
    fetchServiceSolutions(PATH),
  ]);

  return {
    props: { posts, relatedSolutions },
    revalidate: 300,
  };
}

export default AiIntegrations;
